import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';

export default function GlobalEANBasicInfoComponent({
  handleInnerFormChange, selectedGlobalEAN, parentCategoryList, domainsList
}: any) {

  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              label="EANs"
              name="EANs"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'EANs',
                )
              }}
              type="text"
              value={selectedGlobalEAN?.EANs}
            />
            <InputContainer
              label="Description"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Description'
                );
              }}
              type="text"
              value={selectedGlobalEAN?.Description}
            />
          </div>
        }
        expandedPanel="userInfo"
        headerTitle="Basic Info"
      />
    </>
  )
}